"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TabList", {
  enumerable: true,
  get: function get() {
    return _reactTabs.TabList;
  }
});
Object.defineProperty(exports, "TabPanel", {
  enumerable: true,
  get: function get() {
    return _reactTabs.TabPanel;
  }
});
exports.Tabs = exports.Tab = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactTabs = require("react-tabs");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Tab = function Tab(_ref) {
  var children = _ref.children,
      others = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/_react.default.createElement(_reactTabs.Tab, others, /*#__PURE__*/_react.default.createElement("div", null, children));
};

exports.Tab = Tab;
Tab.tabsRole = 'Tab'; // https://github.com/reactjs/react-tabs#custom-components

var SC = {};
SC.PillTabs = (0, _styledComponents.default)(_reactTabs.Tabs).withConfig({
  displayName: "tabs__PillTabs",
  componentId: "sc-1bn7n2o-0"
})(["width:100%;.react-tabs__tab-list{display:flex;align-items:center;justify-content:center;padding:0;margin:0;list-style:none;}.react-tabs__tab{margin-right:8px;border-radius:999px;padding:2px;cursor:pointer;user-select:none;div{color:", ";border-radius:999px;height:30px;line-height:26px;font-size:14px;padding:0 16px;}i{font-style:normal;}&--selected{box-shadow:0 2px 20px 2px rgba(134,19,214,0.06);background-image:linear-gradient(to bottom right,#aa89ed,#0cccef);div{color:#303030;background:#fff;}i{color:#0cccef;}}}"], function (props) {
  return props.theme.colors.cadetBlue;
});
SC.InlineTabs = (0, _styledComponents.default)(_reactTabs.Tabs).withConfig({
  displayName: "tabs__InlineTabs",
  componentId: "sc-1bn7n2o-1"
})(["width:100%;.react-tabs__tab-list{display:flex;align-items:flex-start;padding:0;margin-bottom:24px;list-style:none;}.react-tabs__tab{cursor:pointer;&:first-child{margin-right:16px;}i{font-style:normal;color:#aaaaaa;}span{cursor:default;color:black;border-bottom:3px solid #25cced;}&--selected{i{color:black;border-bottom:3px solid #25cced;}}}.react-tabs__tab-panel{display:none;&--selected{display:block;}}"]);

var Tabs = function Tabs(_ref2) {
  var _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'pill' : _ref2$type,
      rest = _objectWithoutProperties(_ref2, ["type"]);

  if (type === 'inline') {
    return /*#__PURE__*/_react.default.createElement(SC.InlineTabs, rest);
  }

  return /*#__PURE__*/_react.default.createElement(SC.PillTabs, rest);
};

exports.Tabs = Tabs;